var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<form name=\"renameCard\" ng-submit=\"fnc(cardName)\"> <div class=\"name_input\"> <input type=\"text\" ng-model=\"cardName\" ng-value=\"value\" class=\"form-control\" id=\"renameCardName\" placeholder=\"{{'MYCARDS.CARD_NAME' | translate}}\" validate-title maxlength=\"50\" aria-label=\"Назва картки\" required=\"\"> </div> <div class=\"card_rename_buttons\"> <span class=\"glyphicon glyphicon-remove\" ng-click=\"clearField()\"></span>\n<button class=\"glyphicon glyphicon-ok\" ng-click=\"\"></button> </div> </form>";
ngModule.run(["$templateCache",function(c){c.put("inputfield/templates/field.html",v1)}]);
module.exports=v1;


/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/inputfield/templates/field.html
 ** module id = 51
 ** module chunks = 1
 **/